/**
 * Synthetic catalog option for Quote Builder product select:
 * "Customer Supplied" — same card UX as a normal product, $0 cost/sell.
 */

export const CUSTOMER_SUPPLIED_PRODUCT_ID = 'customer-supplied'

/**
 * @param {{ imageUrl?: string }} [options]
 * @returns {object}
 */
export function createCustomerSuppliedProduct (options = {}) {
  const imageUrl = options.imageUrl || ''
  const images = imageUrl
    ? [{ url: imageUrl, filename: 'customer-supplied-product.png' }]
    : null
  return {
    id: CUSTOMER_SUPPLIED_PRODUCT_ID,
    uuid: CUSTOMER_SUPPLIED_PRODUCT_ID,
    description: 'Customer Supplied',
    name: 'Customer Supplied',
    sell_price: 0,
    cost: 0,
    price_method: 'standard_price',
    markup_pct: null,
    includes_gst: 1,
    customer_supplied: true,
    primary_supplier_code: null,
    supplier_id: null,
    images
  }
}

export function isCustomerSuppliedProduct (product) {
  if (!product || typeof product !== 'object') return false
  if (product.customer_supplied === true) return true
  return String(product.id) === CUSTOMER_SUPPLIED_PRODUCT_ID ||
    String(product.uuid) === CUSTOMER_SUPPLIED_PRODUCT_ID
}
